import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.ContactRequestCard.SalesSettingsSection', {
    header: 'SALES SETTINGS',
    defaultAccount: 'Default account',
    trackingOption: 'Tracking option {index}',
});
